import { PRESET_COLORS } from '@/shared/lib/color';

import { ColorPicker } from './ColorPicker';
import styles from './ColorSwatches.module.css';

interface Props {
  label: string;
  value: string | null;
  onChange: (value: string | null) => void;
  /** Offer an empty "no color" choice (labelled with `noneLabel`). */
  noneLabel?: string;
  /** Color shown in the custom picker while `value` is null. */
  fallback?: string;
}

const OPTIONS = PRESET_COLORS.map((value) => ({ value, label: value }));

/** The free label palette plus any `#rrggbb`: a visible title over the shared `ColorPicker`. */
export function ColorSwatches({ label, value, onChange, noneLabel, fallback }: Props) {
  return (
    <div className={styles.group}>
      <span className={styles.legend}>{label}</span>
      <ColorPicker
        label={label}
        value={value}
        options={OPTIONS}
        onPick={onChange}
        {...(noneLabel !== undefined && { noneLabel })}
        {...(fallback !== undefined && { fallback })}
      />
    </div>
  );
}
